import React, { useState } from "react";

import { useDesktopMediaQuery } from "../../utils/helpers";
import ICONS from "../constants/icons";
import FilterDropdown from "./FilterDropdown";
import FilterSection from "./FilterSection";
import { Filter } from "./types";

import { ProductFilterProps } from "./types";
import styles from "./productFilters.module.css";
import { TagTypes, VariantOptionTypes } from "../../commonTypes";
import { useShopContext } from "../../context/ShopContext";
import { useUser } from "../../context/UserContext";
import { useRouter } from "next/router";
import { getTagsAsFilter } from "../../utils/productFunctions";
import classNames from "classnames";
import ProductSearchActiveFilters from "./productSearch/productSearchActiveFilters";
import ProductSearch from "./productSearch/productSearch";

// const groupedFilter = {
//   "size-0-3m": ["size-3m", "size-56/62-(0-3m)"],
// };

const ProductFilters = ({
  handleFilters,
  activeFilters,
}: ProductFilterProps): JSX.Element => {
  const isDesktop = useDesktopMediaQuery();
  const { productTags, variantOptions } = useShopContext();
  const { user } = useUser();
  const [isMobileFilterVisible, setIsMobileFilterVisible] = useState(false);

  const router = useRouter();

  // TODO - populate these functions for the products when ready
  const handleTagClick = ({ name, value }: Filter) => {
    // Additional filter amendments 20/02/23 ********************************
    // Adds additional values to certain size filters, also hides those additional from ui
    let arrValue: string[] = [];

    //@ts-ignore
    let searchParams = { ...router.query };

    // ensure it's an array
    searchParams.q =
      typeof searchParams.q === "string" ? [searchParams.q] : searchParams.q;

    if (!searchParams.q) {
      searchParams.q = [];
    }

    if (searchParams.q.indexOf(value) > -1) {
      // Filter already exists, so lets remove

      //single value
      searchParams.q.splice(searchParams.q.indexOf(value), 1);
    } else {
      //single value
      searchParams.q.push(value);
    }

    router.query = searchParams;
    router.push(router, undefined, {
      scroll: false,
      shallow: true, // tell next that it doesnt need to refresh all the data when navigation
    });
  };

  let priorityTags = [
    {
      name: "Availability",
      filters: [
        { name: "include sold out items", value: "product-not-available" },
      ],
    },
    {
      name: "Categories",
      filters: getTagsAsFilter(productTags, TagTypes.CATEGORY),
    },
    {
      name: "Concept",
      filters: getTagsAsFilter(productTags, TagTypes.CONCEPT),
    },
  ];

  if (user) {
    priorityTags.push({
      name: "My Or",
      filters: [{ name: "Previously Rented", value: "previously-rented" }],
    });
  }

  const subFilterTags = [
    {
      name: "Age",
      filters: getTagsAsFilter(variantOptions, VariantOptionTypes.SIZE),
    },
    {
      name: "Brand",
      filters: getTagsAsFilter(productTags, TagTypes.BRAND),
    },
    {
      name: "Colour",
      filters: getTagsAsFilter(variantOptions, VariantOptionTypes.COLOR),
    },
    {
      name: "Season",
      filters: getTagsAsFilter(productTags, TagTypes.SEASON),
    },
  ];

  const filters = (
    <>
      {priorityTags.map(
        (filterOpt: { name: string; filters: Filter[] }, index) => {
          return (
            <FilterSection
              title={filterOpt.name}
              filters={filterOpt.filters}
              key={index}
              activeFilters={activeFilters}
              onClick={handleTagClick}
            />
          );
        }
      )}
      {subFilterTags.map(
        (filterOpt: { name: string; filters: Filter[] }, index) => {
          return (
            <FilterDropdown
              title={filterOpt.name}
              additionalHidden={[]}
              filters={filterOpt.filters}
              activeFilters={activeFilters}
              key={index}
              onClick={handleTagClick}
            />
          );
        }
      )}
    </>
  );

  return (
    <>
      {!isDesktop ? (
        <div>
          <div
            className={classNames(styles.container, {
              [styles.containerTop]: isMobileFilterVisible,
            })}
          >
            <div
              className={styles.filterButton}
              onClick={() => setIsMobileFilterVisible(!isMobileFilterVisible)}
            >
              Filter ({activeFilters.length})
            </div>
            {/* <div className={styles.sortButton}>Sort By</div> */}
          </div>

          <div
            className={classNames(styles.mobileFilters, {
              [styles.mobileFiltersVisible]: isMobileFilterVisible,
            })}
          >
            <button
              className={styles.closeMobileFilter}
              onClick={() => setIsMobileFilterVisible(false)}
            >
              <ICONS.CLOSE size={20} />
            </button>
            <ProductSearch
              activeFilters={activeFilters}
              onClickIcon={() => setIsMobileFilterVisible(false)}
            />
            {filters}
          </div>

          {/* Mobiel Filter Overview */}
          <div className={styles.activeFilter}>
            <ProductSearchActiveFilters activeFilters={activeFilters} />
          </div>
        </div>
      ) : (
        <div className={styles.desktopContainer}>
          <div className={styles.filterSection}>
            <div className={styles.title}>Filters</div>
          </div>
          {filters}
        </div>
      )}
    </>
  );
};

export default ProductFilters;
